module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row col-xs no-margin no-padding between-xs middle-xs"
  }, [_c('div', {
    staticClass: "filter-bar"
  }, [_c('div', {
    staticClass: "flex middle-xs"
  }, [_c('span', {
    staticClass: "f4 fw4"
  }, [_vm._v("From ")]), _vm._v(" "), _c('span', {
    staticClass: "search-date-picker"
  }, [_c('flat-pickr', {
    staticClass: "filter-date-picker",
    staticStyle: {
      "color": "#000"
    },
    attrs: {
      "config": _vm.config,
      "placeholder": "Select a date"
    },
    model: {
      value: (_vm.min_date),
      callback: function($$v) {
        _vm.min_date = $$v
      },
      expression: "min_date"
    }
  }), _vm._v(" "), _vm._m(0)], 1), _vm._v(" "), _c('span', {
    staticClass: "f4 fw4"
  }, [_vm._v(" to ")]), _vm._v(" "), _c('span', {
    staticClass: "search-date-picker"
  }, [_c('flat-pickr', {
    staticClass: "filter-date-picker",
    staticStyle: {
      "color": "#000"
    },
    attrs: {
      "config": _vm.config,
      "placeholder": "Select a date"
    },
    model: {
      value: (_vm.max_date),
      callback: function($$v) {
        _vm.max_date = $$v
      },
      expression: "max_date"
    }
  }), _vm._v(" "), _vm._m(1)], 1), _vm._v(" "), _c('pl-button', {
    staticClass: "pl-primary search-button",
    staticStyle: {
      "margin": "2px 10px",
      "width": "150px"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.searchAnalytics.apply(null, arguments)
      }
    }
  }, [_vm._v("\n        SEARCH\n      ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "last-updated"
  }, [_vm._v("(last updated " + _vm._s(_vm.latest_update) + ")")]), _vm._v(" "), (_vm.message_error) ? _c('div', [_c('span', {
    staticClass: "red"
  }, [_vm._v("\n        Please check selected dates. End date must be greater than begin date\n        and date interval must be less than two years.")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row col-xs end-xs middle-xs"
  }, [_c('toggle-button', {
    attrs: {
      "sync": true,
      "labels": true,
      "value": _vm.trial_teachers_active,
      "color": "#72ccd7"
    },
    on: {
      "change": function($event) {
        return _vm.handleTrialTeachers($event)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "ml2 fw4 trial-teacher-span",
    on: {
      "click": function($event) {
        _vm.trial_teachers_modal = true
      }
    }
  }, [_vm._v("\n      Trial Teachers\n    ")])], 1), _vm._v(" "), (_vm.trial_teachers_modal) ? _c('div', [_c('trial-teachers-modal', {
    on: {
      "close": function($event) {
        _vm.trial_teachers_modal = false
      },
      "searchAnalytics": _vm.searchAnalytics
    }
  })], 1) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "input-button clickable",
    attrs: {
      "data-toggle": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-caret-down",
    staticStyle: {
      "font-size": "16px",
      "color": "#000",
      "margin-right": "20px"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "input-button clickable",
    attrs: {
      "data-toggle": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-caret-down",
    staticStyle: {
      "font-size": "16px",
      "color": "#000"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-e56a9774!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/admin/adminPortal/analytics/adminPortalAnalyticsFiltersBar.vue
// module id = 2138
// module chunks = 61